'use strict';

var RootCtrl = require('./app/RootCtrl.js');
var ErrorCtrl = require('./app/ErrorCtrl.js');
require('./auth/UserActivateCtrl.js');
var ResetPasswordCtrl = require('./auth/ResetPasswordCtrl.js');
var UsersResetPasswordCtrl = require('./auth/UsersResetPasswordCtrl.js');


// How it works
require('./how-it-works/HowToCtrl.js');
var HowToCtrl = require('./how-it-works/HowToCtrl.js');

// User profile
require('./user/UserActivateAliasCtrl.js');

// Companies
var CompanyCtrl = require('./company/CompanyCtrl.js');
var CompanyNavCtrl = require('./company/CompanyNavCtrl.js');
var CompanyMenuTopCtrl = require('./company/CompanyMenuTopCtrl.js');
require('./company/CompanySettingsCtrl.js');
var CompanySettingThreeLoginCtrl = require('./company/settings/CompanySettingThreeLoginCtrl.js');
var CompanySettingCategoriesCtrl = require('./company/settings/CompanySettingCategoriesCtrl.js');
var CompanySettingCategoryGroupsCtrl = require('./company/settings/CompanySettingCategoryGroupsCtrl.js');
var CompanySettingTaskStatusesCtrl = require('./company/settings/CompanySettingTaskStatusesCtrl.js');
var CompanySettingTaskTypesCtrl = require('./company/settings/CompanySettingTaskTypesCtrl.js');
var CompanySettingGroupsCtrl = require('./company/settings/CompanySettingGroupsCtrl.js');
var CompanySettingStatusesCtrl= require('./company/settings/CompanySettingStatusesCtrl.js');
var CompanySettingTaskCategoriesCtrl= require('./company/settings/CompanySettingTaskCategoriesCtrl.js');
var CompanySettingNoticeCategoriesCtrl= require('./company/settings/CompanySettingNoticeCategoriesCtrl.js');

var CompanySettingsClassesCtrl = require('./company/CompanySettingsClassesCtrl.js');
var CompanyDefaultGroupCtrl = require('./company/CompanyDefaultGroupCtrl.js');
var CompanyAccountCtrl = require('./company/CompanyAccountCtrl.js');
var CompanyDetailCtrl = require('./company/account/CompanyDetailCtrl.js');
require('./company/account/CompanyEmbedCtrl.js');
var CompanyTagSuggestionCtrl = require('./company/account/CompanyTagSuggestionCtrl.js');
var CompanyFlowVerifyDetailCtrl = require('./company/account/CompanyFlowVerifyDetailCtrl.js');

// Companies - Publications
var CompanyPublicationCtrl = require('./company/publications/CompanyPublicationCtrl.js');
var PublicationCollabrationCtrl = require('./publication-collabrations/PublicationCollabrationCtrl.js');
var CompanyPublicationsListCtrl = require('./company/publications/CompanyPublicationsListCtrl.js');
var CompanyPublicationsListDraftsCtrl = require('./company/publications/CompanyPublicationsListDraftsCtrl.js');
var CompanyPublicationsListArchivedCtrl = require('./company/publications/CompanyPublicationsListArchivedCtrl.js');
var CompanyPublicationsListStarredCtrl = require('./company/publications/CompanyPublicationsListStarredCtrl.js');
var CompanyPublicationsListWatchedCtrl = require('./company/publications/CompanyPublicationsListWatchedCtrl.js');
var CompanyPublicationsFlowVerifiesCtrl = require('./company/publications/CompanyPublicationsFlowVerifiesCtrl.js');
var CompanyPublicationDetailCtrl = require('./company/publications/CompanyPublicationDetailCtrl.js');
var PublicationCollabrationDetailCtrl = require('./publication-collabrations/PublicationCollabrationDetailCtrl.js');
var CompanyPublicationShareAccessCtrl = require('./company/publications/CompanyPublicationShareAccessCtrl.js');
var CompanyPublicationVersionsCtrl = require('./company/publications/CompanyPublicationVersionsCtrl.js');
var CompanyPublicationIndexCtrl = require('./company/publications/CompanyPublicationIndexCtrl.js');
var CompanyPublicationsNewCtrl = require('./company/publications/CompanyPublicationsNewCtrl.js');

// Companies - Customer portals
var CompanyCustomerPortalsCtrl = require('./company/customer-portals/CompanyCustomerPortalsCtrl.js');
var CompanyCustomerPortalsListCtrl = require('./company/customer-portals/CompanyCustomerPortalsListCtrl.js');
var CompanyCustomerPortalsNewCtrl = require('./company/customer-portals/CompanyCustomerPortalsNewCtrl.js');
var CompanyCustomerPortalsDetailCtrl = require('./company/customer-portals/CompanyCustomerPortalsDetailCtrl.js');

// Form app submit group
var FormAppSubmitGroupNewCtrl = require('./company/form-app-submit-group/FormAppSubmitGroupNewCtrl.js');
var FormAppSubmitGroupDetailCtrl = require('./company/form-app-submit-group/FormAppSubmitGroupDetailCtrl.js');
// Companies - Guest
var CompanyGuestCtrl = require('./company-guest/CompanyGuestCtrl.js');
var CompanyGuestNavCtrl = require('./company-guest/CompanyGuestNavCtrl.js');

// Companies - Comments
var CompanyGuestCommentsCtrl = require('./company-guest/comments/CompanyGuestCommentsCtrl.js');
// Companies - Guest - Publications
var CompanyGuestPublicationsCtrl = require('./company-guest/publications/CompanyGuestPublicationsCtrl.js');
var CompanyGuestPublicationsListCtrl = require('./company-guest/publications/CompanyGuestPublicationsListCtrl.js');
var CompanyGuestPublicationsListStarredCtrl = require('./company-guest/publications/CompanyGuestPublicationsListStarredCtrl.js');
var CompanyGuestPublicationsDetailCtrl = require('./company-guest/publications/CompanyGuestPublicationsDetailCtrl.js');

var CompanyGuestUsersListCtrl = require('./company-guest/users/CompanyGuestUsersListCtrl.js');
var CompanyGuestUsersProfileCtrl = require('./company-guest/users/CompanyGuestUsersProfileCtrl.js');

// Companies - Guest - Albums
var CompanyGuestAlbumsCtrl = require('./company-guest/albums/CompanyGuestAlbumsCtrl.js');
var CompanyGuestAlbumsDetailCtrl = require('./company-guest/albums/CompanyGuestAlbumsDetailCtrl.js');

// Companies - Guest - Notes
require('./company-guest/notes/CompanyGuestNotesCtrl.js');
var CompanyGuestNotesDetailCtrl = require('./company-guest/notes/CompanyGuestNotesDetailCtrl.js');

// Companies - Guest - Folders
require('./company-guest/folders/CompanyGuestFoldersCtrl.js');
var CompanyGuestFoldersDetailCtrl = require('./company-guest/folders/CompanyGuestFoldersDetailCtrl.js');

// Companies - Guest - Keypasses
require('./company-guest/keypasses/CompanyGuestKeypassesCtrl.js');
var CompanyGuestKeypassesDetailCtrl = require('./company-guest/keypasses/CompanyGuestKeypassesDetailCtrl.js');

 //Companies - Guest - Wall
var CompanyGuestWallDetailCtrl = require('./company-guest/wall/CompanyGuestWallDetailCtrl.js');

//Companies - Guest - Plant
var CompanyGuestPlantDetailCtrl = require('./company-guest/plants/CompanyGuestPlantDetailCtrl.js');

//Companies - Guest - Customer Adaption
var CompanyGuestCustomerAdaptionDetailCtrl = require('./company-guest/customer-adaption/CompanyGuestCustomerAdaptionDetailCtrl.js');

//companies - Guest - Engine model
var CompanyGuestEngineModelDetailCtrl = require('./company-guest/engine-model/CompanyGuestEngineModelDetailCtrl.js');

//Companies - Guest - Publication group
var CompanyGuestPublicationGroupDetailCtrl = require('./company-guest/publication-group/CompanyGuestPublicationGroupDetailCtrl.js');

var CompanyGuestCompanyOrderDetailCtrl = require('./company-guest/company-order/CompanyGuestCompanyOrderDetailCtrl.js');

var CompanyGuestPublicationOrderDetailCtrl = require('./company-guest/order/CompanyGuestPublicationOrderDetailCtrl.js');

var CompanyGuestPublicationBlogDetailCtrl = require('./company-guest/blog/CompanyGuestPublicationBlogDetailCtrl.js');

// Address book
require('./company/AddressBookCtrl.js');
var AddressBookCtrl = require('./company/AddressBookCtrl.js');
var CompanyAddressBookCtrl = require('./company/CompanyAddressBookCtrl.js');

//Comments
require('./company/comments/CompanyActivitiesCtrl.js');
require('./company/comments/CompanyNotificationsCtrl.js');
var CompanyCommentsCtrl = require('./company/comments/CompanyCommentsCtrl.js');
var CompanyMessageDetailCtrl = require('./company/blogs/CompanyMessageDetailCtrl.js');
var CompanyShareLinksCtrl = require('./company/comments/CompanyShareLinksCtrl.js');

//Customers dashboard
var CompanyCustomersDashboardCtrl = require('./company/customers-dashboard/CompanyCustomersDashboardCtrl.js');
var CompanyCustomerDetailCtrl = require('./company/customers-dashboard/CompanyCustomerDetailCtrl.js');

var CompanyCustomerServiceListCtrl = require('./company/customer-service/CompanyCustomerServiceListCtrl.js');

var CompanyTimestampDetailCtrl = require('./company/timestamps/CompanyTimestampDetailCtrl.js');

var CompanyGdprContactListCtrl = require('./company/gdpr/contacts/CompanyGdprContactListCtrl.js');
var CompanyGdprContactNewCtrl = require('./company/gdpr/contacts/CompanyGdprContactNewCtrl.js');
var CompanyGdprContactEditCtrl = require('./company/gdpr/contacts/CompanyGdprContactEditCtrl.js');

//Publication Order Report
var CompanyPublicationOrderReportCtrl = require('./company/publications/order/CompanyPublicationOrderReportCtrl.js');

//Publication Plant Report
var CompanyPublicationPlantReportCtrl = require('./company/publications/plant/CompanyPublicationPlantReportCtrl.js');

//Company Investigation List View
var CompanyInvestigationListCtrl = require('./company/investigation-list/CompanyInvestigationListCtrl.js');

//Company Checklist
var CompanyChecklistCtrl = require('./company/checklist/CompanyChecklistCtrl.js');

// Company User roles
var CompanyUserRoleCtrl = require('./company/user-roles/CompanyUserRoleCtrl.js');
var CompanyUserRoleListCtrl = require('./company/user-roles/CompanyUserRoleListCtrl.js');
var CompanyUserRoleEditCtrl = require('./company/user-roles/CompanyUserRoleEditCtrl.js');
require('./company/user-roles/CompanyUserRoleNewCtrl.js');

// Company deviation watchers
var CompanyDeviationWatcherListCtrl = require('./company/deviation-watchers/CompanyDeviationWatcherListCtrl.js');
var CompanyDeviationWatcherNewCtrl = require('./company/deviation-watchers/CompanyDeviationWatcherNewCtrl.js');
var CompanyDeviationWatcherEditCtrl = require('./company/deviation-watchers/CompanyDeviationWatcherEditCtrl.js');

// Email to Object
var EmailToObjectCtrl = require('./company/email-to-object/EmailToObjectCtrl.js');
var EmailToObjectListCtrl = require('./company/email-to-object/EmailToObjectListCtrl.js');
var EmailToObjectEditCtrl = require('./company/email-to-object/EmailToObjectEditCtrl.js');
require('./company/email-to-object/EmailToObjectNewCtrl.js');

// Email to task
var EmailToTaskCtrl = require('./company/email-to-task/EmailToTaskCtrl.js');
var EmailToTaskListCtrl = require('./company/email-to-task/EmailToTaskListCtrl.js');
var EmailToTaskEditCtrl = require('./company/email-to-task/EmailToTaskEditCtrl.js');
require('./company/email-to-task/EmailToTaskNewCtrl.js');

function config(
  $stateProvider,
  $urlRouterProvider,
  $locationProvider
) {
  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('!');

  $stateProvider
    .state('reset', {
      url: '/reset-password',
      templateUrl: 'partials/reset-password.html',
      controller: 'ResetPasswordCtrl',
      resolve: ResetPasswordCtrl.resolve,
      data: {
        class: "login__body",
        tab: "reset"
      }
    })
    .state('user-reset-password', {
      url: '/users/:userId/reset-password?code',
      templateUrl: 'partials/user-reset-password.html',
      controller: 'UsersResetPasswordCtrl',
      resolve: UsersResetPasswordCtrl.resolve
    })
    .state('activate', {
      url: '/users/activate?code&email&company',
      templateUrl: 'partials/signup.html',
      controller: 'UserActivateCtrl',
      data: {
        class: "login__body"
      }
    })
    // Activate alias
    .state('activate-alias', {
      url: '/users/activate-alias?code&email',
      controller: 'UserActivateAliasCtrl'
    })


    // Error pages
    .state('403', {
      url: "/403",
      templateUrl: 'partials/errors/403.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve,
      data: {
        class: "error__body"
      }
    })
    .state('404', {
      url: "/404",
      templateUrl: 'partials/errors/404.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve,
      data: {
        class: "error__body"
      }
    })
    .state('error', {
      url: "/error",
      templateUrl: 'partials/errors/error.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve
    })

    .state('root', {
      views: {
        "": {
          templateUrl: 'partials/main.html',
          controller: 'RootCtrl',
          resolve: RootCtrl.resolve
        },
        'header@root': {
          templateUrl: "partials/header.html"
        }
      },
      resolve: RootCtrl.resolve
    })
    .state('root.publication-collabration', {
      url: '/publication-collabrations/:publicationId?showInvisible&page&searchFile',
      abstract: true,
      templateUrl: 'partials/publication-collabrations/main.html',
      controller: 'PublicationCollabrationCtrl',
      resolve: PublicationCollabrationCtrl.resolve
    })
    .state('root.publication-collabration.detail', {
      url: '',
      templateUrl: 'partials/publication-collabrations/detail.html',
      controller: 'PublicationCollabrationDetailCtrl',
      resolve: PublicationCollabrationDetailCtrl.resolve
    })

    // How it works
    .state('root.markdown', {
      url: '/markdown-help',
      templateUrl: 'partials/how-it-works/how-it-works.html',
      controller: 'HowToCtrl',
      resolve: HowToCtrl.resolve
    })

    // Company
    .state('root.company', {
      url: '/companies/:companyId?userType&pageCat&showAll&type',
      abstract: true,
      views: {
        'header@root': {
          templateUrl: 'partials/company/header.html',
          controller: 'CompanyNavCtrl',
          resolve: CompanyNavCtrl.resolve
        },
        '': {
          templateUrl: 'partials/company/main.html',
          controller: 'CompanyCtrl',
        }
      },
      resolve: CompanyCtrl.resolve
    })

    // Menu
    .state('root.company.menu', {
      url: '/menu',
      templateUrl: 'partials/company/menu-top.html',
      controller: 'CompanyMenuTopCtrl',
      resolve: CompanyMenuTopCtrl.resolve
    })

    // Company guests
    .state('root.company-guest', {
      url: '/companies/:companyId/guest',
      views: {
        'header@root': {
          templateUrl: 'partials/company-guest/header.html',
          controller: 'CompanyGuestNavCtrl',
          resolve: CompanyGuestNavCtrl.resolve
        },
        '': {
          templateUrl: 'partials/company-guest/main.html',
          controller: 'CompanyGuestCtrl',
          resolve: CompanyGuestCtrl.resolve
        }
      },
      resolve: CompanyGuestCtrl.resolve
    })

    .state('root.company-guest.comments', {
      url: '/comments?query&page&orderBy&type',
      templateUrl: 'partials/company-guest/comments/main.html',
      controller: 'CompanyGuestCommentsCtrl',
      resolve: CompanyGuestCommentsCtrl.resolve
    })

    // Company guests publication
    .state('root.company-guest.publications', {
      url: '/publications',
      templateUrl: 'partials/company-guest/publications/main.html',
      controller: 'CompanyGuestPublicationsCtrl',
      resolve: CompanyGuestPublicationsCtrl.resolve
    })
    .state('root.company-guest.publications.list', {
      url: '/?q&qType&page&groupId&categoryId&reference&keypass&type',
      templateUrl: 'partials/company-guest/publications/list.html',
      controller: 'CompanyGuestPublicationsListCtrl',
      resolve: CompanyGuestPublicationsListCtrl.resolve
    })
    .state('root.company-guest.publications.listStarred', {
      url: '/starred?page',
      templateUrl: 'partials/company-guest/publications/list.html',
      controller: 'CompanyGuestPublicationsListStarredCtrl',
      resolve: CompanyGuestPublicationsListStarredCtrl.resolve
    })
    .state('root.company-guest.publications.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestPublicationsDetailCtrl',
      resolve: CompanyGuestPublicationsDetailCtrl.resolve
    })
    .state('root.company-guest.profiles', {
      url: '/profiles?page&emailPrefix&type',
      templateUrl: 'partials/company-guest/profiles/list.html',
      controller: 'CompanyGuestUsersListCtrl',
      resolve: CompanyGuestUsersListCtrl.resolve
    })
    .state('root.company-guest.profile', {
      url: '/profiles/:userId',
      templateUrl: 'partials/company-guest/profiles/profile.html',
      controller: 'CompanyGuestUsersProfileCtrl',
      resolve: CompanyGuestUsersProfileCtrl.resolve
    })

    // Company guest folders:
    .state('root.company-guest.folder', {
      url: '/folder',
      templateUrl: 'partials/company-guest/folders/main.html',
      controller: 'CompanyGuestFoldersCtrl'
    })
    .state('root.company-guest.folder.detail', {
      url: '/:publicationId?page&searchFile',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestFoldersDetailCtrl',
      resolve: CompanyGuestFoldersDetailCtrl.resolve
    })

    // Company guest albums:
    .state('root.company-guest.album', {
      url: '/album/:publicationId',
      templateUrl: 'partials/company-guest/albums/main.html',
      abstract: true,
      controller: 'CompanyGuestAlbumsCtrl',
      resolve: CompanyGuestAlbumsCtrl.resolve
    })
    .state('root.company-guest.album.detail', {
      url: '?showInvisible&page&searchFile',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestAlbumsDetailCtrl',
      resolve: CompanyGuestAlbumsDetailCtrl.resolve
    })

    // Company guest sk3 folder:
    .state('root.company-guest.sk3-folder', {
      url: '/sk3-folder/:publicationId',
      templateUrl: 'partials/company-guest/sk3-folder/main.html',
      abstract: true,
      controller: 'CompanyGuestAlbumsCtrl',
      resolve: CompanyGuestAlbumsCtrl.resolve
    })
    .state('root.company-guest.sk3-folder.detail', {
      url: '?showInvisible&page&searchFile',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestAlbumsDetailCtrl',
      resolve: CompanyGuestAlbumsDetailCtrl.resolve
    })

    // Company guest notes:
    .state('root.company-guest.note', {
      url: '/note',
      templateUrl: 'partials/company-guest/notes/main.html',
      controller: 'CompanyGuestNotesCtrl'
    })
    .state('root.company-guest.note.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestNotesDetailCtrl',
      resolve: CompanyGuestNotesDetailCtrl.resolve
    })

    // Company guest keypass:
    .state('root.company-guest.keypass', {
      url: '/keypass',
      templateUrl: 'partials/company-guest/keypasses/main.html',
      controller: 'CompanyGuestKeypassesCtrl'
    })

    .state('root.company-guest.keypass.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestKeypassesDetailCtrl',
      resolve: CompanyGuestKeypassesDetailCtrl.resolve
    })

    // Company guest Wall:
    .state('root.company-guest.wall', {
      url: '/wall',
      templateUrl: 'partials/company-guest/wall/main.html'
    })

    .state('root.company-guest.wall.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestWallDetailCtrl',
      resolve: CompanyGuestWallDetailCtrl.resolve
    })

    // Company guest Plant:
    .state('root.company-guest.plant', {
      url: '/plant',
      templateUrl: 'partials/company-guest/plants/main.html'
    })

    .state('root.company-guest.plant.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestPlantDetailCtrl',
      resolve: CompanyGuestPlantDetailCtrl.resolve
    })

    // Company guest customer adaption
    .state('root.company-guest.customer-adaption', {
      url: '/customer_adaption',
      templateUrl: 'partials/company-guest/customer-adaption/main.html'
    })

    .state('root.company-guest.customer-adaption.detail', {
      url: '/:publicationId?page&searchFile',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestCustomerAdaptionDetailCtrl',
      resolve: CompanyGuestCustomerAdaptionDetailCtrl.resolve
    })

    // Company guest engine model
    .state('root.company-guest.engine-model', {
      url: '/engine_model',
      templateUrl: 'partials/company-guest/engine-model/main.html'
    })

    .state('root.company-guest.engine-model.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestEngineModelDetailCtrl',
      resolve: CompanyGuestEngineModelDetailCtrl.resolve
    })

    // Company guest publication group
    .state('root.company-guest.publication-group', {
      url: '/publication_group',
      templateUrl: 'partials/company-guest/publication-group/main.html'
    })

    .state('root.company-guest.publication-group.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestPublicationGroupDetailCtrl',
      resolve: CompanyGuestPublicationGroupDetailCtrl.resolve
    })

    // Company guest company order
    .state('root.company-guest.company-order', {
      url: '/company_order',
      templateUrl: 'partials/company-guest/company-order/main.html'
    })

    .state('root.company-guest.company-order.detail', {
      url: '/:publicationId?page&searchFile',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestCompanyOrderDetailCtrl',
      resolve: CompanyGuestCompanyOrderDetailCtrl.resolve
    })

    // Company guest company order
    .state('root.company-guest.order', {
      url: '/order',
      templateUrl: 'partials/company-guest/order/main.html'
    })

    .state('root.company-guest.order.detail', {
      url: '/:publicationId',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestPublicationOrderDetailCtrl',
      resolve: CompanyGuestPublicationOrderDetailCtrl.resolve
    })

    // Company guest blog
    .state('root.company-guest.blog', {
      url: '/blog',
      templateUrl: 'partials/company-guest/blog/main.html'
    })

    .state('root.company-guest.blog.detail', {
      url: '/:publicationId?page',
      templateUrl: 'partials/company-guest/publications/detail.html',
      controller: 'CompanyGuestPublicationBlogDetailCtrl',
      resolve: CompanyGuestPublicationBlogDetailCtrl.resolve
    })

    // Company settings
    .state('root.company.account.settings', {
      url: '/settings',
      templateUrl: 'partials/company/settings/settings.html',
      controller: 'CompanySettingsCtrl',
      data: {
        ext_class: 'company-account__moving-top'
      }
    })
    .state('root.company.account.settings.three-login', {
      url: '/three-login',
      views: {
        "settings": {
            templateUrl: 'partials/company/settings/three-login.html',
            controller: 'CompanySettingThreeLoginCtrl',
            resolve: CompanySettingThreeLoginCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.statuses', {
      url: '/statuses',
      views: {
        "settings": {
            templateUrl: 'partials/company/settings/statuses.html',
            controller: 'CompanySettingStatusesCtrl',
            resolve: CompanySettingStatusesCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.taskCategories', {
      url: '/task-categories',
      views: {
        "settings": {
            templateUrl: 'partials/company/settings/task-categories.html',
            controller: 'CompanySettingTaskCategoriesCtrl',
            resolve: CompanySettingTaskCategoriesCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.noticeCategories', {
      url: '/notice-categories',
      views: {
        "settings": {
            templateUrl: 'partials/company/settings/notice-categories.html',
            controller: 'CompanySettingNoticeCategoriesCtrl',
            resolve: CompanySettingNoticeCategoriesCtrl.resolve 
        }
      }
    })

    .state('root.company.account.settings.categories', {
      url: '/categories',
      views: {
        "settings": {
          templateUrl: 'partials/company/settings/categories.html',
          controller: 'CompanySettingCategoriesCtrl',
          resolve: CompanySettingCategoriesCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.portal-categories', {
      url: '/portal-categories',
      views: {
        "settings": {
          templateUrl: 'partials/company/settings/portal-categories.html',
          controller: 'CompanySettingCategoryGroupsCtrl',
          resolve: CompanySettingCategoryGroupsCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.task-statuses', {
      url: '/task-statuses',
      views: {
        "settings": {
          templateUrl: 'partials/company/settings/task-statuses.html',
          controller: 'CompanySettingTaskStatusesCtrl',
          resolve: CompanySettingTaskStatusesCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.task-types', {
      url: '/task-types',
      views: {
        "settings": {
          templateUrl: 'partials/company/settings/task-types.html',
          controller: 'CompanySettingTaskTypesCtrl',
          resolve: CompanySettingTaskTypesCtrl.resolve
        }
      }
    })

    .state('root.company.account.settings.classes', {
      url: '/classes',
      views: {
        "settings": {
          templateUrl: 'partials/company/settings/classes.html',
          controller: 'CompanySettingGroupsCtrl',
          resolve: CompanySettingGroupsCtrl.resolve
        }
      }
    })
    .state('root.company.account.settings.classes-detail', {
      url: '/classes/:groupId',
      templateUrl: 'partials/company/settings/classes/edit.html',
      controller: 'CompanySettingsClassesCtrl',
      resolve: CompanySettingsClassesCtrl.resolve,
      data: {
        ext_class: ''
      }
    })

    // Company default group
    .state('root.company.account.settings.default-group', {
      url: '/default-group',
      templateUrl: 'partials/company/settings/default-group/default-group.html',
      controller: 'CompanyDefaultGroupCtrl',
      resolve: CompanyDefaultGroupCtrl.resolve,
      data: {
        ext_class: ''
      }
    })

    // Company account
    .state('root.company.account', {
      abstract: true,
      url: '/account?uType',
      templateUrl: 'partials/company/account/account.html',
      controller: 'CompanyAccountCtrl',
      resolve: CompanyAccountCtrl.resolve
    })

    .state('root.company.account.detail', {
      url: '/detail',
      templateUrl: 'partials/company/account/detail/details.html',
      controller: 'CompanyDetailCtrl',
      resolve: CompanyDetailCtrl.resolve
    })

    .state('root.company.account.information', {
      url: '/information',
      templateUrl: 'partials/company/account/detail/presentation.html'
    })

    .state('root.company.account.embed', {
      url: '/embed',
      templateUrl: 'partials/company/account/detail/embed.html',
      controller: 'CompanyEmbedCtrl'
    })

    .state('root.company.account.tagSuggestion', {
      url: '/tag-suggestion',
      templateUrl: 'partials/company/account/detail/smartphone.html',
      controller: 'CompanyTagSuggestionCtrl',
      resolve: CompanyTagSuggestionCtrl.resolve
    })

    .state('root.company.account.flow-verify', {
      url: '/flow-verify/:flowVerifyID',
      templateUrl: 'partials/company/account/detail/flow-verify-detail.html',
      controller: 'CompanyFlowVerifyDetailCtrl',
      resolve: CompanyFlowVerifyDetailCtrl.resolve
    })
    .state('root.company.account.checklist', {
      url: '/checklist',
      templateUrl: 'partials/company/checklist/list.html',
      controller: 'CompanyChecklistCtrl',
      resolve: CompanyChecklistCtrl.resolve
    })

    .state('root.company.investigation-list', {
      url: '/investigation-list?page&status&qInves&step',
      templateUrl: 'partials/company/investigation-list/main.html',
      controller: 'CompanyInvestigationListCtrl',
      resolve: CompanyInvestigationListCtrl.resolve
    })

    // Company publications
    .state('root.company.publications-list', {
      url: '/?q&qType&qTypeObject&categoryId&priorityId&groupId&tags&page&pageCat&reference&keypass&from&to&orderby&openSearchSidebar&edit&asc&togFilter&year&month',
      templateUrl: 'partials/company/publications/list.html',
      controller: 'CompanyPublicationsListCtrl',
      resolve: CompanyPublicationsListCtrl.resolve
    })

    //publications list
    .state('root.company.publications-listDrafts', {
      url: '/drafts?page&priorityId',
      templateUrl: 'partials/company/publications/another-list.html',
      controller: 'CompanyPublicationsListDraftsCtrl',
      resolve: CompanyPublicationsListDraftsCtrl.resolve
    })
    .state('root.company.publications-listArchived', {
      url: '/archived?q&qType&qTypeObject&page&priorityId&queryArchived',
      templateUrl: 'partials/company/publications/another-list.html',
      controller: 'CompanyPublicationsListArchivedCtrl',
      resolve: CompanyPublicationsListArchivedCtrl.resolve
    })
    .state('root.company.publications-listStarred', {
      url: '/starred?page&priorityId&queryStarred',
      templateUrl: 'partials/company/publications/another-list.html',
      controller: 'CompanyPublicationsListStarredCtrl',
      resolve: CompanyPublicationsListStarredCtrl.resolve
    })
    .state('root.company.publications-listWatched', {
      url: '/watched?page&queryWatched',
      templateUrl: 'partials/company/publications/another-list.html',
      controller: 'CompanyPublicationsListWatchedCtrl',
      resolve: CompanyPublicationsListWatchedCtrl.resolve
    })
    .state('root.company.publications-flowVerifies', {
      url: '/flow-verifies?page&manager&status',
      templateUrl: 'partials/company/publications/flow-verify-list.html',
      controller: 'CompanyPublicationsFlowVerifiesCtrl',
      resolve: CompanyPublicationsFlowVerifiesCtrl.resolve
    })
    .state('root.company.publication-new', {
      url: '/new?activeTab&pubCopyId',
      templateUrl: 'partials/company/publications/create/view.html',
      controller: 'CompanyPublicationsNewCtrl',
      resolve: CompanyPublicationsNewCtrl.resolve
    })
    .state('root.company.publication', {
      url: '/publications/:publicationId?fromPortal',
      templateUrl: 'partials/company/publications/main.html',
      abstract: true,
      controller: 'CompanyPublicationCtrl',
      resolve: CompanyPublicationCtrl.resolve
    })
    .state('root.company.publication.detail', {
      url: '?showInvisible&page&searchFile',
      templateUrl: 'partials/company/publications/detail/latest.html',
      controller: 'CompanyPublicationDetailCtrl',
      resolve: CompanyPublicationDetailCtrl.resolve
    })
    .state('root.company.publication.share-access', {
      url: '/share-access?page',
      templateUrl: 'partials/company/publications/detail/share-access.html',
      controller: 'CompanyPublicationShareAccessCtrl',
      resolve: CompanyPublicationShareAccessCtrl.resolve
    })
    .state('root.company.publication.versions', {
      url: '/versions?page',
      templateUrl: 'partials/company/publications/detail/versions.html',
      controller: 'CompanyPublicationVersionsCtrl',
      resolve: CompanyPublicationVersionsCtrl.resolve
    })
    .state('root.company.publication.index', {
      url: '/index?page',
      templateUrl: 'partials/company/publications/detail/index.html',
      controller: 'CompanyPublicationIndexCtrl',
      resolve: CompanyPublicationIndexCtrl.resolve
    })
    .state('root.company.publication.pdf-viewer', {
      url: '/pdf-viewer',
      templateUrl: 'partials/company/publications/detail/pdf-viewer.html'
    })
    .state('root.company.publication.order-report', {
      url: '/order-report?page&from&to&t',
      templateUrl: 'partials/company/publications/order-report/main.html',
      controller: 'CompanyPublicationOrderReportCtrl',
      resolve: CompanyPublicationOrderReportCtrl.resolve
    })

    .state('root.company.publication.plant-report', {
      url: '/plant-report/:plantId?page&from&to&t',
      templateUrl: 'partials/company/publications/plant-report/main.html',
      controller: 'CompanyPublicationPlantReportCtrl',
      resolve: CompanyPublicationPlantReportCtrl.resolve
    })

    // Company customer portals
    .state('root.company.customerPortals', {
      url: '/customer-portals',
      templateUrl: 'partials/company/customer-portals/main.html',
      controller: 'CompanyCustomerPortalsCtrl',
      resolve: CompanyCustomerPortalsCtrl.resolve
    })
    .state('root.company.customerPortals.list', {
      url: '/?page&userId&query&categoryId&tab',
      templateUrl: 'partials/company/customer-portals/tab-main.html',
      controller: 'CompanyCustomerPortalsListCtrl',
      resolve: CompanyCustomerPortalsListCtrl.resolve
    })
    .state('root.company.customerPortals.new', {
      url: '/new?publicationId&isCreateFormApp',
      templateUrl: 'partials/company/customer-portals/form.html',
      controller: 'CompanyCustomerPortalsNewCtrl',
      resolve: CompanyCustomerPortalsNewCtrl.resolve
    })
    .state('root.company.customerPortals.detail', {
      url: '/:customerPortalId?year&month&priorityId',
      templateUrl: 'partials/company/customer-portals/detail.html',
      controller: 'CompanyCustomerPortalsDetailCtrl',
      resolve: CompanyCustomerPortalsDetailCtrl.resolve
    })

    // Form app submit group
    .state('root.company.formAppGroups', {
      url: '/form-app-groups',
      templateUrl: 'partials/company/form-app-submit-group/main.html'
    })
    .state('root.company.formAppGroups.new', {
      url: '/new',
      templateUrl: 'partials/company/form-app-submit-group/form.html',
      controller: 'FormAppSubmitGroupNewCtrl',
      resolve: FormAppSubmitGroupNewCtrl.resolve
    })
    .state('root.company.formAppGroups.detail', {
      url: '/:groupId',
      templateUrl: 'partials/company/form-app-submit-group/detail.html',
      controller: 'FormAppSubmitGroupDetailCtrl',
      resolve: FormAppSubmitGroupDetailCtrl.resolve
    })

    // Address book:
    .state('root.address-book', {
      url: '/address-book',
      templateUrl: 'partials/company/address-book.html',
      controller: 'AddressBookCtrl',
      resolve: AddressBookCtrl.resolve
    })

    // Address book:
    .state('root.company.contacts', {
      url: '/contacts',
      templateUrl: 'partials/company/contacts.html',
      controller: 'CompanyAddressBookCtrl',
      resolve: CompanyAddressBookCtrl.resolve
    })

    .state('root.company.comments', {
      url: '?query&page&orderBy&type',
      templateUrl: 'partials/company/comments/main.html',
      controller: 'CompanyCommentsCtrl',
      resolve: CompanyCommentsCtrl.resolve
    })

    .state('root.company.comments.list', {
      url: '/comments',
      templateUrl: 'partials/company/comments/comments.html'
    })

    .state('root.company.comments.activities', {
      url: '/activities',
      templateUrl: 'partials/company/comments/audit-logs.html',
      controller: 'CompanyActivitiesCtrl'
    })

    .state('root.company.comments.notifications', {
      url: '/notifications',
      templateUrl: 'partials/company/comments/notifications.html',
      controller: 'CompanyNotificationsCtrl'
    })

    .state('root.company.comments.share-links', {
      url: '/share-links?filter&active',
      templateUrl: 'partials/company/comments/share-links.html',
      controller: 'CompanyShareLinksCtrl',
      resolve: CompanyShareLinksCtrl.resolve
    })

    .state('root.company.comments.messages', {
      url: '/messages',
      templateUrl: 'partials/company/comments/comments.html'
    })

    .state('root.company.message-new', {
      url: '/messages/new',
      templateUrl: 'partials/company/blogs/new.html',
      controller: 'CompanyMessageDetailCtrl',
      resolve: CompanyMessageDetailCtrl.resolve
    })

    .state('root.company.message-detail', {
      url: '/messages/:messageId',
      templateUrl: 'partials/company/blogs/detail.html',
      controller: 'CompanyMessageDetailCtrl',
      resolve: CompanyMessageDetailCtrl.resolve
    })

    .state('root.company.timestamps', {
      url: '/timestamps',
      templateUrl: 'partials/company/timestamps/main.html'
    })

    .state('root.company.timestamps.detail', {
      url: '/?manual',
      templateUrl: 'partials/company/timestamps/detail.html',
      controller: 'CompanyTimestampDetailCtrl',
      resolve: CompanyTimestampDetailCtrl.resolve
    })

    .state('root.company.customers-dashboard', {
      url: '/customers-dashboard',
      templateUrl: 'partials/company/customers-dashboard/main.html',
      controller: 'CompanyCustomersDashboardCtrl',
      resolve: CompanyCustomersDashboardCtrl.resolve
    })

    .state('root.company.customers-dashboard.detail', {
      url: '/:customerId?tab',
      templateUrl: 'partials/company/customers-dashboard/detail.html',
      controller: 'CompanyCustomerDetailCtrl',
      resolve: CompanyCustomerDetailCtrl.resolve
    })

    .state('root.company.customer-service', {
      url: '/customer-service',
      templateUrl: 'partials/company/customer-service/main.html',
    })

    .state('root.company.customer-service.list', {
      url: '/?page&typeId?name?manager',
      templateUrl: 'partials/company/customer-service/list.html',
      controller: 'CompanyCustomerServiceListCtrl',
      resolve: CompanyCustomerServiceListCtrl.resolve
    })
    // .state('root.company.edit-dashboard', {
    //   url: '/user-roles/:roleId/dashboard',
    //   templateUrl: 'partials/company/user-roles/edit-dashboard.html',
    //   controller: 'CompanyUserRoleEditCtrl',
    //   resolve: CompanyUserRoleEditCtrl.resolve
    // })

    // gdpr contacts
    .state('root.company.account.gdpr-contacts', {
      abstract: true,
      url: '/gdpr-contacts',
      templateUrl: 'partials/company/gdpr/contacts/main.html',
      data: {
        ext_class: "company-account__moving-top"
      }
    })
    .state('root.company.account.gdpr-contacts.list', {
      url: '/?page',
      templateUrl: 'partials/company/gdpr/contacts/list.html',
      controller: 'CompanyGdprContactListCtrl',
      resolve: CompanyGdprContactListCtrl.resolve
    })

    .state('root.company.account.gdpr-contacts.new', {
      url: '/new',
      templateUrl: 'partials/company/gdpr/contacts/new.html',
      controller: 'CompanyGdprContactNewCtrl',
      resolve: CompanyGdprContactNewCtrl.resolve
    })

    .state('root.company.account.gdpr-contacts.edit', {
      url: '/:contactId',
      templateUrl: 'partials/company/gdpr/contacts/edit.html',
      controller: 'CompanyGdprContactEditCtrl',
      resolve: CompanyGdprContactEditCtrl.resolve
    })

    .state('root.company.account.user-roles', {
      abstract: true,
      url: '/user-roles',
      templateUrl: 'partials/company/user-roles/main.html',
      controller: 'CompanyUserRoleCtrl',
      resolve: CompanyUserRoleCtrl.resolve
    })
    .state('root.company.account.user-roles.list', {
      url: '/list?page',
      templateUrl: 'partials/company/user-roles/list.html',
      controller: 'CompanyUserRoleListCtrl',
      resolve: CompanyUserRoleListCtrl.resolve,
      data: {
        ext_class: "company-account__moving-top"
      }
    })
    .state('root.company.account.user-roles.new', {
      url: '/new',
      templateUrl: 'partials/company/user-roles/new.html',
      controller: 'CompanyUserRoleNewCtrl',
      data: {
        ext_class: "company-account__moving-top"
      }
    })
    .state('root.company.account.user-roles.edit', {
      url: '/:roleId',
      templateUrl: 'partials/company/user-roles/edit.html',
      controller: 'CompanyUserRoleEditCtrl',
      resolve: CompanyUserRoleEditCtrl.resolve,
      data: {
        ext_class: "company-account__moving-top"
      }
    })

    .state('root.company.account.deviation-settings', {
      url: '/deviation-settings',
      templateUrl: 'partials/company/settings/deviation-settings.html'
    })

    .state('root.company.account.deviation-watchers', {
      abstract: true,
      url: '/deviation-watchers',
      templateUrl: 'partials/company/deviation-watchers/main.html'
    })
    .state('root.company.account.deviation-watchers.list', {
      url: '/list?page',
      templateUrl: 'partials/company/deviation-watchers/list.html',
      controller: 'CompanyDeviationWatcherListCtrl',
      resolve: CompanyDeviationWatcherListCtrl.resolve,
      data: {
        ext_class: "company-account__moving-top"
      }
    })
    .state('root.company.account.deviation-watchers.new', {
      url: '/new',
      templateUrl: 'partials/company/deviation-watchers/new.html',
      controller: 'CompanyDeviationWatcherNewCtrl',
      data: {
        ext_class: "company-account__moving-top"
      }
    })
    .state('root.company.account.deviation-watchers.edit', {
      url: '/:deviationWatcherId',
      templateUrl: 'partials/company/deviation-watchers/edit.html',
      controller: 'CompanyDeviationWatcherEditCtrl',
      resolve: CompanyDeviationWatcherEditCtrl.resolve,
      data: {
        ext_class: "company-account__moving-top"
      }
    })

    .state('root.company.account.email', {
      url: '/emails',
      controller: 'EmailToObjectCtrl',
      templateUrl: 'partials/company/email-to-object/main.html',
      resolve: EmailToObjectCtrl.resolve
    })

    .state('root.company.account.email.list', {
      url: '/list?page',
      templateUrl: 'partials/company/email-to-object/list.html',
      controller: 'EmailToObjectListCtrl',
      resolve: EmailToObjectListCtrl.resolve,
    })

    .state('root.company.account.email.new', {
      url: '/new',
      templateUrl: 'partials/company/email-to-object/new.html',
      controller: 'EmailToObjectNewCtrl'
    })

    .state('root.company.account.email.edit', {
      url: '/:emailId',
      templateUrl: 'partials/company/email-to-object/edit.html',
      controller: 'EmailToObjectEditCtrl',
      resolve: EmailToObjectEditCtrl.resolve
    })

    // email to task
    .state('root.company.account.email-to-task', {
      url: '/email-to-task',
      controller: 'EmailToTaskCtrl',
      templateUrl: 'partials/company/email-to-task/main.html',
      resolve: EmailToTaskCtrl.resolve
    })

    .state('root.company.account.email-to-task.list', {
      url: '/list?page',
      templateUrl: 'partials/company/email-to-task/list.html',
      controller: 'EmailToTaskListCtrl',
      resolve: EmailToTaskListCtrl.resolve,
    })

    .state('root.company.account.email-to-task.new', {
      url: '/new',
      templateUrl: 'partials/company/email-to-task/new.html',
      controller: 'EmailToTaskNewCtrl'
    })

    .state('root.company.account.email-to-task.edit', {
      url: '/:emailToTaskId',
      templateUrl: 'partials/company/email-to-task/edit.html',
      controller: 'EmailToTaskEditCtrl',
      resolve: EmailToTaskEditCtrl.resolve
    })

    // Company error pages
    .state('root.company.403', {
      templateUrl: 'partials/errors/403.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve
    })
    .state('root.company.error', {
      templateUrl: 'partials/errors/error.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve
    })
    .state('root.company.404', {
      templateUrl: 'partials/errors/404.html',
      controller: 'ErrorCtrl',
      resolve: ErrorCtrl.resolve
    });
}

angular.module('dokiv')
  .config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    config
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/routes.js
// module id = 433
// module chunks = 0